import {
    CUSTOM_FIELD_TYPE
} from "@src/views/panel/custom-fields/misc/constants";
import { boolean, mixed, object, number } from "yup";
import Validations from "@src/utility/helpers/validations";
import size from "lodash/size";

export const customFieldsSchema = (customFields) => {
    const {
        minMaxRequiredString,
        minMaxString,
        numberValidation,
        emailCommonValidation,
        requiredValidation
    } = Validations();
    
    if (!size(customFields)) return object();
    const schema = {};

    customFields.forEach((field) => {
        let fieldSchema;
        switch (field.type) {
        case CUSTOM_FIELD_TYPE.TEXT:
        case CUSTOM_FIELD_TYPE.TEXT_AREA: {
            const min = field.validation?.minLength;
            const max = field.validation?.maxLength;

            if (field.required) {
                fieldSchema = minMaxRequiredString({
                    name: field.label,
                    min,
                    max
                });
            } else {
                fieldSchema = minMaxString({
                    name: field.label,
                    min,
                    max
                });
            }
            break;
        }
        case CUSTOM_FIELD_TYPE.NUMBER: {
            const min = field.validation?.minVal;
            const max = field.validation?.maxVal;

            if (field.required) {
                fieldSchema = numberValidation({
                    name: field.label,
                    min : min ?? undefined,
                    max : max ?? undefined
                });
            } else {
                fieldSchema = number()
                    .transform((value, originalValue) => (originalValue === "" ? undefined : value)
                    )
                    .typeError(`${field.label} must be a valid number`)
                    .nullable();

                if (min !== undefined) {
                    fieldSchema = fieldSchema.min(
                        min,
                        `${field.label} must be greater than or equal to ${min}`
                    );
                }

                if (max !== undefined) {
                    fieldSchema = fieldSchema.max(
                        max,
                        `${field.label} must be less than or equal to ${max}`
                    );
                }
            }

            break;
        }

        case CUSTOM_FIELD_TYPE.EMAIL: {
            fieldSchema = emailCommonValidation({
                name    : field.label,
                required: field.required
            });
            break;
        }

        case CUSTOM_FIELD_TYPE.CHECKBOX:
            if (field.required) {
                fieldSchema = boolean()
                    .oneOf([true], `${field.label} is required`)
                    .required(`${field.label} is required`);
            } else {
                fieldSchema = boolean().nullable();
            }
            break;
            
        case CUSTOM_FIELD_TYPE.SELECT:
            if (field.required) {
                fieldSchema = mixed()
                    .required(`${field.label} is required`)
                    .test(
                        "not-empty",
                        `${field.label} is required`,
                        (value) => value !== null && value !== undefined && value !== ""
                    );
            } else {
                fieldSchema = mixed().nullable();
            }
            break;
            
        default:
            if (field.required) {
                fieldSchema = requiredValidation({ name: field.label });
            } else {
                fieldSchema = mixed().nullable().notRequired();
            }
        }

        schema[field.key] = fieldSchema;
    });

    return object(schema);
};